import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import DnDList from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

const ChangePositionList: React.FC = () => {
	const nameHeadingClasses = classNames(style.name, style.heading);
	const developerHeadingClasses = classNames(style.developer, style.heading);
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const applicationIdHeadingClasses = classNames(style.applicationId, style.heading);
	const versionCodeHeadingClasses = classNames(style.versionCode, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={developerHeadingClasses}
					translationNameSpace="listing"
					translationKey="developerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={applicationIdHeadingClasses}
					translationNameSpace="listing"
					translationKey="applicationIdLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={versionCodeHeadingClasses}
					translationNameSpace="listing"
					translationKey="versionCodeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};

export default ChangePositionList;
